import * as React from 'react';
import RawHtml from 'react-raw-html';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';

import {
  IProductInfo,
  IReduxRouterAction,
  ISessionInfo,
  IState,
  IUserInfo
} from '../CustomTypes';

import { push } from 'redux-router';

import './ReceiptPage.scss';
/* tslint:disable:max-line-length */

import {
  apiStatuses,
  FetchProductInfo,
  fetchUpsaleProductInfo,
  logException,
  LogException,
  productInfoDeferred,
  sendLoginLink
} from '../actions/Actions';
import {
  createLoginSpidLoginLinkWithRedirectUrl,
  getClientId,
  getRedirectDataFromLocalStorage,
  getUrlForPage,
  toTitleCase,
  triggerHotjar
} from '../fastflowUtils';

import { svgCheck } from '../icons';
import { Button, FamilySharing } from '../input-components/InputComponents';

import {
  sccPulseTrackerInit,
  sccPulseTrackPageView,
  sccPulseTrackPurchase,
  sccPulseUpdate
} from '../PulseUtils';
import './ReceiptPage.scss';

export interface IReceiptPageParamProps {
  productInfo: IProductInfo;
  sessionInfo: ISessionInfo;
  userInfo: IUserInfo;
  referer: string;
  redirectUri: string;
  source?: string;
  medium?: string;
  content?: string;
  campaign?: string;
  term?: string;
  sig: string;
  spidId: string;
  paymentMethodId: string;
  paymentType: string;
  subscriptionId: string;
  duplicate: boolean;
  upsaleProductInfo: IProductInfo;
}

export interface IReceiptPageActionProps {
  sendLoginLink: sendLoginLink;
  push: IReduxRouterAction;
  logException: LogException;
  fetchUpsaleProductInfo: FetchProductInfo;
}

export interface IReceiptPageProps
  extends IReceiptPageParamProps,
    IReceiptPageActionProps {}

export interface IReceiptPageState {
  showSentLoginLink: boolean;
}

export class ReceiptPage extends React.Component<
  IReceiptPageProps,
  IReceiptPageState
> {
  constructor(props: IReceiptPageProps) {
    super(props);
    this.receiptPageOrRedirectAsUrl = this.receiptPageOrRedirectAsUrl.bind(
      this
    );
    this.goToReceiptPageOrRedirect = this.goToReceiptPageOrRedirect.bind(this);
    this.goToSpidLogin = this.goToSpidLogin.bind(this);
    this.sendLoginLink = this.sendLoginLink.bind(this);
    this.getTrackingClickEventName = this.getTrackingClickEventName.bind(this);
    this.buyUpsaleProduct = this.buyUpsaleProduct.bind(this);
    this.showUpsaleBox = this.showUpsaleBox.bind(this);
    this.replaceProperties = this.replaceProperties.bind(this);
    this.state = {
      showSentLoginLink: false
    };
  }

  public componentDidMount() {
    if (this.showUpsaleBox()) {
      this.props.fetchUpsaleProductInfo(
        this.props.productInfo.upsaleSubscriptionConfigurationId
      );
    }

    const redirectData = getRedirectDataFromLocalStorage();
    productInfoDeferred.promise.then(product => {
      triggerHotjar('trigger', `ff-receipt-${product.productId}`);

      const owningClientId = getClientId(this.props.productInfo.owningClient);

      // Send a track event
      if (this.props.duplicate) {
        sccPulseTrackPageView(product, this.props.userInfo, 'Duplicate');
      } else {
        sccPulseTrackerInit(this.props.productInfo.owningClient);
        sccPulseUpdate({
          actor: {
            id: this.props.spidId,
            realm: 'spid.no'
          }
        });
        sccPulseTrackPurchase(
          this.props.productInfo,
          redirectData,
          this.props.paymentType,
          this.props.subscriptionId,
          owningClientId
        );
      }
    });
  }

  public render() {
    const loggedIn: boolean =
      this.props.sessionInfo.apiStatus === apiStatuses.SUCCESS;
    const { firstName, spidPrimaryEmail } = this.props.userInfo;
    const {
      header,
      owningClientName,
      goDirectlyToReceiptPage,
      receiptPageAboveButton,
      receiptPageButton,
      receiptPageNotLoggedInButton,
      showFamilySharing
    } = this.props.productInfo;
    const receiptPageCenter = this.replaceProperties(
      this.props.productInfo.receiptPageCenter
    );
    const receiptPageBottom = this.replaceProperties(
      this.props.productInfo.receiptPageBottom
    );
    const { showSentLoginLink } = this.state;
    const firstNameCorrectCase = toTitleCase(firstName);

    let productName = 'artikkel';
    if (!this.props.redirectUri) {
      productName = owningClientName;
    }

    const duplicate = this.props.duplicate || false;
    const goToReceiptPageOrRedirect: boolean =
      loggedIn || goDirectlyToReceiptPage;
    return (
      <div className="receipt">
        <div className="container">
          <div className="headingWidth">
            <h1>{svgCheck()}</h1>
            <h1>Hei, {firstNameCorrectCase}</h1>

            {!duplicate && (
              <div>
                <h4>
                  Ditt abonnement på {header} er nå opprettet. Vi håper du blir
                  fornøyd!
                </h4>
                {receiptPageCenter && (
                  <RawHtml.p>{receiptPageCenter}</RawHtml.p>
                )}
              </div>
            )}

            {duplicate && (
              <h4>
                Du har allerede et abonnement hos oss, og trenger derfor ikke å
                bestille på nytt.
              </h4>
            )}

            {showFamilySharing && <FamilySharing />}

            <div className="row">
              <div className="col-xs-12">
                {receiptPageAboveButton ? (
                  <RawHtml.p>{receiptPageAboveButton}</RawHtml.p>
                ) : null}
                {goToReceiptPageOrRedirect && (
                  <Button
                    data-href={this.receiptPageOrRedirectAsUrl()}
                    onClick={this.goToReceiptPageOrRedirect}
                  >
                    {receiptPageButton ? (
                      <RawHtml.span>{receiptPageButton}</RawHtml.span>
                    ) : (
                      `Fortsett til ${productName}`
                    )}
                  </Button>
                )}
                {!goToReceiptPageOrRedirect && (
                  <Button onClick={this.goToSpidLogin}>
                    {receiptPageNotLoggedInButton ? (
                      <RawHtml.span>
                        {receiptPageNotLoggedInButton}
                      </RawHtml.span>
                    ) : (
                      `Logg inn for å lese ${productName}`
                    )}
                  </Button>
                )}
              </div>

              <div className="col-xs-12">
                {!loggedIn && (
                  <p className="loginLinkText">
                    Du er registrert med e-post{' '}
                    <span className="email">{spidPrimaryEmail}</span>.<br />
                    Husker du ikke dine innloggingsdetaljer?{' '}
                    <a href="#" onClick={this.sendLoginLink}>
                      Få tilsendt e-post med lenke som logger deg inn.
                    </a>
                  </p>
                )}
              </div>

              <div className="col-xs-12">
                {showSentLoginLink && (
                  <div className="alert alert-info">
                    Vi har sendt deg en epost til{' '}
                    <span className="email">{spidPrimaryEmail}</span> med en
                    lenke som logger deg inn.
                  </div>
                )}
              </div>
            </div>
            {this.showUpsaleBox() && (
              <div className="row mask">
                <div className="col-xs-12">
                  <p className="salesText">
                    {this.props.productInfo.upsaleHeading}
                  </p>
                  <img
                    className="img-responsive productimage"
                    src={this.props.upsaleProductInfo.imageurl}
                  />
                  <Button onClick={this.buyUpsaleProduct}>
                    {this.props.upsaleProductInfo.orderButtonText}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="extraContent">
          {receiptPageBottom && <RawHtml.p>{receiptPageBottom}</RawHtml.p>}
        </div>
      </div>
    );
  }

  private showUpsaleBox(): boolean {
    return !!(
      this.props.productInfo.upsaleSubscriptionConfigurationId &&
      this.props.subscriptionId
    );
  }

  private goToReceiptPageOrRedirect() {
    const linkType = 'read-on';
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      this.getTrackingClickEventName(),
      { linkType }
    );
    (window as any).location.href = this.receiptPageOrRedirectAsUrl();
  }

  private buyUpsaleProduct() {
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      'click upsale product buy'
    );
    const {
      paymentMethodId,
      spidId,
      sig,
      subscriptionId,
      redirectUri,
      referer
    } = this.props;
    const fullUrlForStartPage = getUrlForPage(
      this.props.productInfo.upsaleSubscriptionConfigurationId,
      'start'
    );
    (window as any).location = `${fullUrlForStartPage}?paymentMethodId=${paymentMethodId}&purchasedSubscriptionId=${subscriptionId}&referer=${encodeURIComponent(
      referer
    )}&redirectUri=${encodeURIComponent(
      redirectUri
    )}&spidId=${spidId}&sig=${sig}`;
  }

  private goToSpidLogin() {
    const linkType = 'login';
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      this.getTrackingClickEventName(),
      { linkType }
    );
    const { owningClient, spidTeaser } = this.props.productInfo;
    window.location.replace(
      createLoginSpidLoginLinkWithRedirectUrl(
        owningClient,
        this.props.userInfo.spidPrimaryEmail,
        this.receiptPageOrRedirectAsUrl(),
        spidTeaser
      )
    );
  }

  private sendLoginLink() {
    this.props.sendLoginLink(
      this.props.userInfo.spidPrimaryEmail,
      this.receiptPageOrRedirectAsUrl()
    );
    this.setState({ showSentLoginLink: true });
    const linkType = 'login-link epost';
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      this.getTrackingClickEventName(),
      { linkType }
    );
  }

  private receiptPageOrRedirectAsUrl() {
    const {
      productInfo: { receiptPageButtonUrl },
      redirectUri
    } = this.props;
    if (receiptPageButtonUrl) {
      return receiptPageButtonUrl;
    }
    if (redirectUri) {
      return decodeURIComponent(redirectUri);
    }
    const loggedIn = this.props.sessionInfo.apiStatus === apiStatuses.SUCCESS;
    const {
      subscriptionTypeId,
      subscriptionConfigurationId,
      owningClient
    } = this.props.productInfo;
    return `${location.protocol}//${
      location.host
    }/bestilling/receiptpage.htms?subscriptionTypeId=${subscriptionTypeId}&_skjemaId=${subscriptionConfigurationId}&client=${owningClient}&loggedIn=${loggedIn}`;
  }

  private getTrackingClickEventName() {
    return this.props.duplicate
      ? 'click duplicate'
      : 'click order confirmation';
  }

  private replaceProperties(text: string) {
    const {
      firstName,
      lastName,
      spidPrimaryEmail,
      spidId
    } = this.props.userInfo;
    return (
      text &&
      text
        .replace('${spidId}', '' + spidId)
        .replace('${email}', '' + spidPrimaryEmail)
        .replace('${firstName}', '' + firstName)
        .replace('${lastName}', '' + lastName)
    );
  }
}

export default connect(
  (state: IState) =>
    ({
      campaign: state.router.location.query.utm_campaign,
      content: state.router.location.query.utm_content,
      duplicate: state.router.location.query.duplicate === 'true' || false,
      medium: state.router.location.query.utm_medium,
      paymentMethodId: state.router.location.query.paymentMethodId,
      paymentType: state.router.location.query.paymentType,
      productInfo: state.productInfo,
      redirectUri: state.router.location.query.redirectUri,
      referer: state.router.location.query.referer,
      sessionInfo: state.sessionInfo,
      sig: state.router.location.query.sig,
      source: state.router.location.query.utm_source,
      spidId: state.router.location.query.spidId,
      subscriptionId: state.router.location.query.subscriptionId,
      term: state.router.location.query.utm_term,
      upsaleProductInfo: state.upsaleProductInfo,
      userInfo: state.userInfo
    } as IReceiptPageParamProps),
  dispatch =>
    bindActionCreators(
      { logException, sendLoginLink, push, fetchUpsaleProductInfo },
      dispatch
    ) as IReceiptPageActionProps
)(ReceiptPage);



// WEBPACK FOOTER //
// ./src/page-components/ReceiptPage.tsx